/* ==================================================================
   Page Favoris (Wishlist Hero) — /a/wishlist-hero/*
   Chargé UNIQUEMENT sur cette page via layout/theme.liquid.

   Problème : le bouton « Ajouter au panier » de l'app échoue en 422 pour les
   ABONNEMENTS (« La variante peut seulement être achetée avec un forfait de
   vente ») — l'app poste la variante sans selling plan. Décision (Quentin) :
   rediriger le clic vers la FICHE PRODUIT (le client y choisit le forfait),
   pour abonnements ET produits classiques — cohérent avec les cartes de l'accueil
   qui pointent vers la fiche.
   ================================================================== */
(function () {
  'use strict';

  var SEL_BTN = '.wishlist-hero-list-card-footer-add-to-cart';
  var LABEL = 'Voir le produit';

  /* 1) Intercepter le clic AVANT le handler React de l'app (phase CAPTURE au niveau
        document, donc avant la délégation d'événements de React qui écoute en bubbling),
        empêcher l'ajout panier, et naviguer vers l'URL produit de la carte cliquée. */
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      var btn = target && target.closest ? target.closest(SEL_BTN) : null;
      if (!btn) return;
      var card = btn.closest('.wishlist-hero-list-card');
      var link = card && card.querySelector('a[href*="/products/"]');
      if (!link) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.assign(link.getAttribute('href'));
    },
    true
  );

  /* 2) Libellé « Ajouter au panier » → « Voir le produit ». Le texte est généré par
        l'app (dashboard Wishlist Hero) ; on le force ici et on le ré-applique après
        chaque rendu React via un MutationObserver (débattu par requestAnimationFrame). */
  function relabel() {
    var btns = document.querySelectorAll(SEL_BTN);
    for (var i = 0; i < btns.length; i++) {
      var lbl = btns[i].querySelector('.MuiButton-label') || btns[i];
      if (lbl.textContent.trim() !== LABEL) lbl.textContent = LABEL;
    }
  }

  function start() {
    relabel();
    var root = document.getElementById('wishlist-hero-shared-list-view') || document.body;
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        relabel();
      });
    });
    obs.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* 3) « Tout mettre au panier » → redirection vers le panier (retour cliente).
        Le bouton `-add-all-to-cart-dialog` ouvre une confirmation ; l'app ajoute ensuite
        tous les articles au panier en AJAX. On NE réimplemente PAS l'ajout (les abonnements
        nécessitent un forfait, cf. §1) : on surveille /cart.js et, dès que le nombre
        d'articles a augmenté PUIS s'est stabilisé (ajouts terminés), on va sur /cart.
        Si la cliente annule la confirmation, le compteur ne bouge pas → aucune redirection. */
  var SEL_ADD_ALL = '.wishlist-hero-list-card-footer-add-all-to-cart-dialog';
  var watching = false;

  function fetchCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.item_count; })
      .catch(function () { return null; });
  }

  function watchCartThenRedirect() {
    if (watching) return;
    watching = true;

    var baseline = null;
    var lastCount = null;
    var stableTicks = 0;
    var elapsed = 0;
    var INTERVAL = 500;
    var MAX = 25000; // au-delà : confirmation annulée / rien ajouté → on abandonne

    fetchCartCount().then(function (n) {
      baseline = n == null ? 0 : n;
      lastCount = baseline;
    });

    var timer = setInterval(function () {
      elapsed += INTERVAL;
      fetchCartCount().then(function (n) {
        if (n == null || baseline == null) return;
        if (n > baseline) {
          if (n === lastCount) {
            stableTicks++;
            if (stableTicks >= 1) {
              clearInterval(timer);
              window.location.assign('/cart');
              return;
            }
          } else {
            stableTicks = 0;
          }
        }
        lastCount = n;
        if (elapsed >= MAX) {
          clearInterval(timer);
          watching = false;
        }
      });
    }, INTERVAL);
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      var btn = t && t.closest ? t.closest(SEL_ADD_ALL) : null;
      if (btn) watchCartThenRedirect();
    },
    true
  );
})();
